import { cn } from "@/lib/utils";
import evler from "@/assets/cat/evler.webp";
import menziller from "@/assets/cat/menziller.webp";
import baglar from "@/assets/cat/baglar.webp";
import ofisler from "@/assets/cat/ofisler.webp";
import obyektler from "@/assets/cat/obyektler.webp";
import masinlar from "@/assets/cat/masinlar.webp";
import motosikletler from "@/assets/cat/motosikletler.webp";
import ikiTekerli from "@/assets/cat/iki-tekerli-neqliyyat.webp";
import telefonlar from "@/assets/cat/telefonlar.webp";
import elektronika from "@/assets/cat/elektronika.webp";
import meiset from "@/assets/cat/meiset-esyalari.webp";
import mebel from "@/assets/cat/mebel.webp";
import geyim from "@/assets/cat/geyim.webp";
import usaq from "@/assets/cat/usaq-alemi.webp";
import heyvanlar from "@/assets/cat/heyvanlar.webp";
import xidmetler from "@/assets/cat/xidmetler.webp";
import isElanlari from "@/assets/cat/is-elanlari.webp";
import masaj from "@/assets/cat/masaj.webp";
import reklam from "@/assets/cat/reklam.webp";
import kosmetoloq from "@/assets/cat/kosmetoloq.webp";
import ayaqqabi from "@/assets/cat/ayaqqabi.webp";
import aksesuar from "@/assets/cat/aksesuar.webp";
import qizilZinet from "@/assets/cat/qizil-zinet.webp";

export const categoryImages: Record<string, string> = {
  evler,
  menziller,
  baglar,
  ofisler,
  obyektler,
  masinlar,
  motosikletler,
  "iki-tekerli-neqliyyat": ikiTekerli,
  telefonlar,
  elektronika,
  "meiset-esyalari": meiset,
  mebel,
  geyim,
  "usaq-alemi": usaq,
  heyvanlar,
  xidmetler,
  "is-elanlari": isElanlari,
  masaj,
  kosmetoloq,
  reklam,
  ayaqqabi,
  aksesuar,
  "qizil-zinet": qizilZinet,
};

const icons = categoryImages;

/** Kateqoriya üçün realistik 3D ikon şəkli. */
export function CategoryIcon({
  slug,
  name,
  fallback,
  className,
}: {
  slug: string;
  name: string;
  fallback?: string;
  className?: string;
}) {
  const src = icons[slug];
  if (!src) {
    if (!fallback) return null;
    return (
      <span
        aria-label={`${name} kateqoriyası`}
        className={cn("grid place-items-center text-3xl leading-none", className)}
      >
        {fallback}
      </span>
    );
  }
  return (
    <img
      src={src}
      alt={`${name} kateqoriyası`}
      loading="lazy"
      decoding="async"
      width={160}
      height={160}
      className={cn("size-9 object-contain drop-shadow-sm", className)}
    />
  );
}
